// src/features/project/projectSlice.js
import { createSlice } from '@reduxjs/toolkit';

const projectSlice = createSlice({
  name: 'project',
  initialState: {
    project: [],
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {
    setProject: (state, action) => {
      state.project = action.payload;
      console.log("Redux: Project data updated", state.project);
    },
    setStatus: (state, action) => {
      state.status = action.payload;
      console.log("Redux: Status updated", state.status);
    },
    setError: (state, action) => {
      state.error = action.payload;
      console.log("Redux: Error updated", state.error);
    },
  },
});

export const { setProject, setStatus, setError } = projectSlice.actions;

export default projectSlice.reducer;

// Selector functions
export const selectProject = (state) => state.project.project;
export const selectStatus = (state) => state.project.status;
export const selectError = (state) => state.project.error;